/**
 * Label — vendored from shadcn/ui on @radix-ui/react-label (style guide §7.2):
 * 13/500 navy-950, 6px above its control. The required marker is the word
 * "Required" in navy-600 at the right, never an asterisk; pass it as a child.
 */
import * as React from 'react'
import * as LabelPrimitive from '@radix-ui/react-label'

import { cn } from './cn'

export const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(
      'flex items-center justify-between text-body-sm font-medium text-navy-950 peer-disabled:cursor-not-allowed peer-disabled:text-navy-600',
      className,
    )}
    {...props}
  />
))
Label.displayName = LabelPrimitive.Root.displayName
